import Vue from "vue";
window.Vue = Vue;
globalThis.Vue = Vue;

import VuejsDialog from "vuejs-dialog";
import Editor from "@tinymce/tinymce-vue";
import "vue-select/dist/vue-select.css";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap'
import toastr from 'toastr'
window.toastr = toastr
globalThis.toastr = toastr

window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.SITE_CONFIG.csrfToken;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

export const eventBus = new Vue();

Vue.config.devtools = true;

/**
 * AUTO COMPONENT LOADER
 */
const modules = import.meta.glob('./components/**/*.vue', { eager: true })
// const jsModules = import.meta.glob('./components/**/*.js', { eager: true })

const register = (modules) => {
	Object.entries(modules).forEach(([path, module]) => {
		const component = module.default
		if (!component) return

		const name = path
			.split('/')
			.pop()
			.replace(/\.\w+$/, '')

		Vue.component(
			name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
			component
		)
	})
}

register(modules)
// register(jsModules)

/**
 * MANUAL COMPONENTS
 */
Vue.component('editor', Editor)

/**
 * Plugins
 */
Vue.use(VuejsDialog);
import('vue-toastr-2/dist/vue-toastr-2.common.js').then((module) => {
	const VueToastr2 = module.default

	Vue.use(VueToastr2)

	window.toastr.options.closeButton = true
	window.toastr.options.progressBar = true
	window.toastr.options.timeOut = 2000
	window.toastr.options.extendedTimeOut = 4000

	const app = new Vue({
		el: '#app'
	})
})

/**
 * Directives
 */
Vue.directive('click-outside', {
	bind(el, binding, vnode) {
		var vm = vnode.context;
		var callback = binding.value;

		el.clickOutsideEvent = function (event) {
			if (!(el == event.target || el.contains(event.target))) {
				return callback.call(vm, event);
			}
		};
		document.body.addEventListener('click', el.clickOutsideEvent);
	},
	unbind(el) {
		document.body.removeEventListener('click', el.clickOutsideEvent);
	}
});
